import React, { useEffect, useRef } from 'react';

const HomeServicesOrbital = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    const setupFibonacciConcentric = () => {
      const container = containerRef.current;
      if (!container) return;
      
      container.innerHTML = "";
      const N = 200;
      const SIZE = 360; // Increased size to match the original
      const DOT_RADIUS = 2;
      const MARGIN = 4;
      const CENTER = SIZE / 2;
      const MAX_RADIUS = 130; // Match the concentric component's maxRadius
      const GOLDEN_ANGLE = Math.PI * (3 - Math.sqrt(5));
      const DURATION = 3;
      const svgNS = "http://www.w3.org/2000/svg";

      const svg = document.createElementNS(svgNS, "svg");
      svg.setAttribute("width", SIZE);
      svg.setAttribute("height", SIZE);
      svg.setAttribute("viewBox", `0 0 ${SIZE} ${SIZE}`);
      svg.style.position = "absolute";
      svg.style.left = "0";
      svg.style.top = "0";
      container.appendChild(svg);

      for (let i = 0; i < N; i++) {
        const idx = i + 0.5;
        const frac = idx / N;
        const r = Math.sqrt(frac) * MAX_RADIUS;
        const theta = idx * GOLDEN_ANGLE;
        const x = CENTER + r * Math.cos(theta);
        const y = CENTER + r * Math.sin(theta);

        const circle = document.createElementNS(svgNS, "circle");
        circle.setAttribute("cx", x);
        circle.setAttribute("cy", y);
        circle.setAttribute("r", DOT_RADIUS);
        circle.setAttribute("fill", "#fff");
        circle.setAttribute("opacity", "0.6");
        svg.appendChild(circle);

        // radius pulse
        const animR = document.createElementNS(svgNS, "animate");
        animR.setAttribute("attributeName", "r");
        animR.setAttribute(
          "values",
          `${DOT_RADIUS * 0.3};${DOT_RADIUS * 2.4};${DOT_RADIUS * 0.3}`
        );
        animR.setAttribute("dur", `${DURATION}s`);
        animR.setAttribute("begin", `${frac * DURATION}s`);
        animR.setAttribute("repeatCount", "indefinite");
        animR.setAttribute("calcMode", "spline");
        animR.setAttribute("keySplines", "0.4 0 0.6 1;0.4 0 0.6 1");
        circle.appendChild(animR);

        // opacity pulse
        const animO = document.createElementNS(svgNS, "animate");
        animO.setAttribute("attributeName", "opacity");
        animO.setAttribute("values", "0.3;1;0.3");
        animO.setAttribute("dur", `${DURATION}s`);
        animO.setAttribute("begin", `${frac * DURATION}s`);
        animO.setAttribute("repeatCount", "indefinite");
        animO.setAttribute("calcMode", "spline");
        animO.setAttribute("keySplines", "0.4 0 0.6 1;0.4 0 0.6 1");
        circle.appendChild(animO);
      }
    };

    setupFibonacciConcentric();
  }, []);

  return (
    <div className="animation-container">
      <div ref={containerRef} className="circle-container"></div>
    </div>
  )
}


export default HomeServicesOrbital;

